// removed by extract-text-webpack-plugin
module.exports = {"tabsWrap":"qempo_FlightSales_tabsWrap-36tCStO","tab":"qempo_FlightSales_tab-3oGahrw","noSales":"qempo_FlightSales_noSales-ofqDGmO","downloadWrap":"qempo_FlightSales_downloadWrap-1A8BFBE","salesWrap":"qempo_FlightSales_salesWrap-20qy2j7"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/flight/components/FlightSales/FlightSales.scss
// module id = 1758
// module chunks = 0